import React from 'react';
import styles from './MenuDivider.module.scss';

const MenuDivider = () => {
    return <div className={styles.menuDivider} />;
};

export default MenuDivider;
